import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ConfirmSuccessIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 64 64"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="#ECFDF3" height="64" rx="32" width="64" />
    <rect fill="#D1FADF" height="48" rx="24" width="48" x="8" y="8" />
    <g clipPath="url(#clip0_4718_45126)">
      <rect fill="#039855" height="32" rx="16" width="32" x="16" y="16" />
      <circle cx="32" cy="32" fill="white" r="9" />
      <path
        clipRule="evenodd"
        d="M32 18.6667C24.6362 18.6667 18.6666 24.6362 18.6666 32C18.6666 39.3638 24.6362 45.3334 32 45.3334C39.3638 45.3334 45.3333 39.3638 45.3333 32C45.3333 24.6362 39.3638 18.6667 32 18.6667ZM38.9428 28.9428C39.4635 28.4221 39.4635 27.5779 38.9428 27.0572C38.4221 26.5365 37.5779 26.5365 37.0572 27.0572L30 34.1144L26.9428 31.0572C26.4221 30.5365 25.5778 30.5365 25.0572 31.0572C24.5365 31.5779 24.5365 32.4221 25.0572 32.9428L29.0572 36.9428C29.5778 37.4635 30.4221 37.4635 30.9428 36.9428L38.9428 28.9428Z"
        fill="#039855"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_4718_45126">
        <rect fill="white" height="32" rx="16" width="32" x="16" y="16" />
      </clipPath>
    </defs>
  </svg>
);

ConfirmSuccessIcon.propTypes = {
  ...sizePropsTypes,
};

export default ConfirmSuccessIcon;
